<template>
  <div
      class="d-flex flex-0-0 fd-column"
      :class="{ 'bd-t-gray30': appointments.length || !isFinishedMatch }">
    <appointment-section
        v-for="{ id } in appointments"
        :key="id"
        :id="id"
        :collapsed="hasMultipleAppointments && collapseState !== id"
        @change="onAppointmentUpdated">
      <a
          v-if="hasMultipleAppointments"
          slot="collapse"
          class="COLLAPSE-BUTTON"
          @click.prevent="toggleCollapse(id)">
        <vk-icon
            v-if="$device.isMobileOrTablet"
            class="d-flex h4"
            :name="collapseState === id ? 'chevronup' : 'chevrondown'" />
        <span v-else>
          {{
            collapseState === id
              ? 'See less'
              : 'See more'
          }}
        </span>
      </a>
    </appointment-section>
    <appointment-section
        v-if="hasNewAppointment"
        v-show="!$device.isMobile"
        key="new-appointment"
        @cancel="onAppointmentCanceled"
        @change="onAppointmentAdded" />
    <dashboard-section
        key="new-button"
        v-if="($device.isMobile|| !hasNewAppointment) && !isFinishedMatch"
        :bordered="$device.isMobileOrTablet">
      <div
          v-if="!$device.isMobile"
          slot="header"
          class="d-flex flex-1-1 ai-center jc-between"
          selenium="appointment-title">
        <span class="d-flex ai-center text-lg text-bold">Appointment</span>
      </div>
      <a
          class="ADD-APPOINTMENT ANCHOR-CONTROLS"
          @click.prevent="onAppointmentAdd"
          selenium="appointment-add-button">
        <vk-icon name="plus-circle-outlined" class="ICON" />Make an appointment
      </a>
    </dashboard-section>
    <dashboard-section v-show="false" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import jobParams from '@/mixins/job-params';
import job from '@/mixins/job';
import appointments from '@/mixins/job/appointments';

import DashboardSection from '@/views/Dashboard/components/DashboardSection';

import AppointmentSection from './AppointmentSection';

export default {
  name: 'pro-appointments',
  components: {
    DashboardSection,
    AppointmentSection,
  },
  mixins: [
    jobParams,
    job,
    appointments,
  ],
  data () {
    return {
      hasNewAppointment: false,
      collapseState: null,
    };
  },
  computed: {
    ...mapGetters('account/pro/info', [
      'serviceProviderId',
    ]),
    ...mapGetters('entities', {
      appointmentEntities: 'appointments',
    }),
    ...mapGetters('dashboard/job', [
      'sortedByUpcomingDateJobAppointments',
    ]),
    // Override mixin's appointments to filter out roofing_installation appointments
    appointments () {
      const allAppointments = this.sortedByUpcomingDateJobAppointments
        .map(appointmentId => this.appointmentEntities[appointmentId])
        .filter(Boolean);
      // Filter out appointments with purpose_description === 'roofing_installation'
      return allAppointments.filter(
        appointment => appointment.purpose_description !== 'roofing_installation'
      );
    },
    hasMultipleAppointments () {
      return this.appointments.length > 1;
    },
  },
  watch: {
    serviceProviderId: {
      immediate: true,
      handler (val) {
        if (val) {
          this.getAppointments();
        }
      },
    },
  },
  mounted () {

  },
  methods: {
    getAppointments () {
      this.fetchAppointments({
        params: {
          size: 100,
          order_hash: this.job.order_hash,
          service_provider_id: this.serviceProviderId,
        },
      });
    },
    onAppointmentAdd () {
      this.hasNewAppointment = true;
    },
    onAppointmentUpdated ({ id }) {
      this.collapseState = id;
      this.getAppointments();
    },
    onAppointmentAdded ({ id }) {
      this.getAppointments();
      this.collapseState = id;
      this.hasNewAppointment = false;
    },
    onAppointmentCanceled () {
      this.hasNewAppointment = false;
    },
    toggleCollapse (id) {
      this.collapseState = this.collapseState === id ? true : id;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .ICON {
    @include h4;
    margin-right: $unit;
  }

  .ADD-APPOINTMENT {
    @include link-primary;
    @include text-large;
    @include hover(text-decoration, none, none);
    display: flex;
    align-items: center;
  }

  .COLLAPSE-BUTTON {
    @include link-primary;
    @include text-medium;

    @include desktop {
      @include absolute(auto, 5*$unit, 3*$unit, auto);
      font-weight: 700;
    }
  }

  .ANCHOR-CONTROLS {
    @include responsive(flex, 1 1 auto, $md: 0 1 auto);
    display: flex;
  }
</style>
